/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, effect, inject, input, signal, viewChild } from '@angular/core';

import { EChartsOption } from 'echarts';

import { MetricService } from '../services/metric.service';
import { StateService } from '../services/state.service';
import { ChartColor, VisualService } from '../services/visual.service';
import { GlobalConstants } from '../../shared/global-constants';

@Component({
  selector: 'app-visual-base',
  standalone: true,
  imports: [],
  template: '',
  styles: []
})
export class VisualBaseComponent {
  chart = viewChild('chart', { read: ElementRef });
  chartColors = input<ChartColor[]>([]);
  information = input<string | null>();
  tourId = input<string>();
  paywall = input<boolean>(false);
  paywallMessage = input<string | null>();
  
  initOptions = { }
  chartOptions: EChartsOption = { }
  updateOptions: EChartsOption = {}
  loadingColor = '#ffffff';

  protected metricService = inject(MetricService);
  protected visualService = inject(VisualService);

  readonly isPrinting = inject(StateService).isPrinting;
  
  protected colors: string[] = GlobalConstants.colors;
  protected chartInit = signal<boolean>(false);
  protected echartsInstance?: any;
  protected baseOptions: EChartsOption = { }
  protected tooltipOptions: EChartsOption = {}
  protected printOptions: EChartsOption = {}

  protected noDataOptions: EChartsOption = {
    title: {
      show: true,
      textStyle: {
        color: 'grey',
        fontSize: 20
      },
      text: 'No Data Available',
      left: 'center',
      top: 'center'
    },
    xAxis: {
      show: false
    },
    yAxis: {
      show: false
    },
    series: []
  };
  protected ariaOptions: EChartsOption = {
    aria: {
      enabled: true,
      label: {
        enabled: true
      },
      decal: {
        show: false
      }
    }
  };

  protected resizedObserver = new ResizeObserver((entries) => {
    if (!this.echartsInstance?.isDisposed()) {
      this.echartsInstance?.resize({ width: entries[0].contentRect.width, height: entries[0].contentRect.height });
    }
  });

  constructor() {
    effect(() => {
      this.resizedObserver.observe(this.chart()?.nativeElement);
    });
  }

  public onChartInit(e: any): void {
    this.echartsInstance = e;
    this.echartsInstance.showLoading({ color: '#38789e', maskColor: this.loadingColor });

    this.setOptions();
    this.chartInit.set(true);
  }

  protected setOptions(): void {
    const options: EChartsOption = {};
    Object.assign(options, this.baseOptions, this.ariaOptions, this.tooltipOptions, this.isPrinting() ? this.printOptions : {});
    this.chartOptions = options;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onChartLegendSelectChanged(event: any) { }
}
